import React from 'react';
import { COLORS, Color } from '../../../styles/variables';

interface SportbackDefaultIconProps {
  color?: Color;
}

const SportbackDefaultIcon: React.FC<SportbackDefaultIconProps> = ({ color = COLORS.black }) => (
  <svg width="76" height="38" viewBox="0 0 76 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_816_44878)">
      <path
        d="M11.49 20.77C10.75 20.77 9.16989 20.87 8.65989 20.95C7.98989 21.06 6.86996 21.4 6.73996 21.79C6.57382 22.2659 6.57382 22.7841 6.73996 23.26C7.65249 23.363 8.575 23.3361 9.47995 23.18C10.2733 22.4774 11.0152 21.7188 11.6999 20.91C11.7999 20.86 11.73 20.76 11.49 20.77Z"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M25.4299 18.21C25.4299 18.21 37.54 17.73 42.35 17.65L63.87 17.35"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M43.3499 13.08L42.5699 17.78"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.1899 14.79L58.7499 17.35"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M66.59 28.25C68.3599 28.1281 70.1223 27.9145 71.87 27.61C73.19 27.32 73.2799 23.86 73.2799 23.86L73.0599 22.58C73.0599 22.58 73.06 21.71 72.96 20.58C73.0801 19.9653 73.0645 19.3318 72.9142 18.7238C72.7639 18.1158 72.4826 17.548 72.09 17.06C71.69 16.82 55 12.16 53.09 11.83C40.03 10.75 34.17 11.7 32.72 12.17C29.2789 13.7105 25.9389 15.4673 22.72 17.43C18.53 17.32 10.51 18.79 8.71998 19.26C6.91254 19.7409 5.21485 20.566 3.71998 21.69C2.31998 22.81 2.20992 25.98 2.40992 27.69C2.60992 29.4 3.85998 29.54 4.58998 29.69C5.31998 29.84 8.74 30.12 8.74 30.12"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M23.73 29.31L52.77 28.46" stroke={color} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M73.09 19.06H69.23C69.1844 19.0618 69.1402 19.076 69.1021 19.1012C69.064 19.1263 69.0336 19.1613 69.0141 19.2025C68.9945 19.2437 68.9866 19.2895 68.9911 19.3349C68.9957 19.3803 69.0126 19.4235 69.04 19.46C69.256 19.829 69.4966 20.1832 69.76 20.52C70.04 20.86 70.5 21.52 71.08 21.6C71.66 21.68 73.2701 21.6 73.2701 21.6"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M22.01 27.33C22.015 27.4066 22.015 27.4834 22.01 27.56C22.01 28.2337 21.8773 28.9008 21.6195 29.5232C21.3617 30.1456 20.9838 30.7111 20.5074 31.1874C20.0311 31.6638 19.4655 32.0417 18.8431 32.2995C18.2207 32.5573 17.5537 32.69 16.88 32.69C15.5212 32.6873 14.2188 32.1457 13.2589 31.1839C12.299 30.2221 11.76 28.9188 11.76 27.56C11.76 26.2021 12.2993 24.8998 13.2595 23.9396C14.2197 22.9794 15.5221 22.44 16.88 22.44C18.0511 22.4366 19.1878 22.8355 20.1 23.57"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M64.72 27.33C64.72 27.41 64.72 27.48 64.72 27.56C64.72 28.9205 64.1795 30.2254 63.2174 31.1874C62.2553 32.1495 60.9505 32.69 59.59 32.69C58.2311 32.6873 56.9289 32.1457 55.969 31.1839C55.0091 30.2221 54.47 28.9188 54.47 27.56C54.47 26.2021 55.0094 24.8998 55.9696 23.9396C56.9298 22.9794 58.2321 22.44 59.59 22.44C60.7611 22.4366 61.8978 22.8355 62.8099 23.57"
        stroke={color}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_816_44878">
        <rect width="71.65" height="22.1" fill="white" transform="translate(2 11)" />
      </clipPath>
    </defs>
  </svg>
);

export default SportbackDefaultIcon;
